export default __webpack_public_path__ + "static/media/patient-booking.2bd6bd91.webp";